export const STRIPE_CONFIG = {
  // Pricing tiers
  TIERS: {
    FREE: 'free',
    PRO: 'pro',
    ENTERPRISE: 'enterprise',
    LIFETIME: 'LIFETIME'
  },

  // Products with pricing and features
  products: {
    free: {
      name: 'Gratuit',
      price: 0,
      features: [
        'Basic trade tracking',
        'Simple analytics',
        'Email support',
        'Community access'
      ]
    },
    pro: {
      name: 'Pro',
      price: 29.99,
      features: [
        'Unlimited trades',
        'Advanced analytics',
        'Priority support',
        'Real-time market data',
        'Custom indicators',
        'Trading journal',
        'Performance metrics',
        'Trading strategy builder',
        'Risk management tools',
        'Portfolio analysis',
        'API access',
        'Seasonality analysis'
      ],
      stripeId: 'price_1QhS6jDayMX7OEpz4TyO2Xln'
    },
    enterprise: {
      name: 'Enterprise',
      price: 99.99,
      features: [
        'All Pro features',
        'Dedicated account manager',
        'Custom integrations',
        'Team collaboration',
        'Advanced API access',
        'Custom reporting',
        'White-label options',
        'On-premise deployment',
        'Custom development',
        'SLA guarantee',
        'Training sessions'
      ],
      stripeId: 'price_1QhS6jDayMX7OEpz4TyO2Xln'
    }
  },

  // Feature comparison for different contexts
  FEATURE_COMPARISON: {
    FREE: [
      'Basic trade tracking',
      'Simple analytics',
      'Email support',
      'Community access'
    ],
    PRO: [
      'Unlimited trades',
      'Advanced analytics',
      'Priority support',
      'Real-time market data',
      'Custom indicators',
      'Trading journal',
      'Performance metrics',
      'Trading strategy builder',
      'Risk management tools',
      'Portfolio analysis',
      'API access',
      'Seasonality analysis'
    ],
    LIFETIME: [
      'Unlimited trades',
      'Advanced analytics',
      'Priority support',
      'Real-time market data',
      'Custom indicators',
      'Trading journal',
      'Performance metrics',
      'Trading strategy builder',
      'Risk management tools',
      'Portfolio analysis',
      'API access',
      'Seasonality analysis'
    ],
    ENTERPRISE: [
      'All Pro features',
      'Dedicated account manager',
      'Custom integrations',
      'Team collaboration',
      'Advanced API access',
      'Custom reporting',
      'White-label options',
      'On-premise deployment',
      'Custom development',
      'SLA guarantee',
      'Training sessions'
    ]
  }
};
